import { createActionTypes } from "@helpers/redux-helpers";

export const signInActionTypes = createActionTypes("signin");

export const signInMetamask = createActionTypes("signIn/metamask");

export const signInGoogle = createActionTypes("signIn/google");

export const signInTwitch = createActionTypes("signIn/twitch");
export const signInTwitter = createActionTypes("signIn/twitter");
export const toggleSignInModalType = "sign-in-modal";
